<template>
  <form-section
    :title="$t('CampaignForm_Locations_AddLocations_Title')"
    :description="$t('CampaignForm_Locations_AddLocations_Description')"
    :separator="true"
    :is-changed="model.diff && model.diff.includes('locations')"
  >
    <add-location-dialog
      v-if="showDialog"
      :location-type="locationType"
      :locations="model.locations"
    />
    <el-table
      v-if="model.locations.length > 0"
      :data="model.locations"
      stripe
      class="locations-table"
    >
      <el-table-column
        prop="type"
        :label="$t('CampaignForm_Locations_AddLocations_Type')"
        :width="140"
      >
        <template slot-scope="scope">
          {{ $t(locationLabels[scope.row.type]) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        :label="$t('CampaignForm_Locations_AddLocations_Location')"
      />
      <el-table-column :width="60">
        <template slot-scope="scope">
          <div class="iconCt">
            <icon
              class="icon"
              glyph="bin"
              @click="removeLocation(scope.$index)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="primary"
      @click="addGeoFence"
      plain
      icon="el-icon-circle-plus-outline"
    >
      {{ $t('CampaignForm_Locations_AddLocations_AddGeoFence') }}
    </el-button>
    <el-button
      type="primary"
      @click="addIBeacon"
      plain
      icon="el-icon-circle-plus-outline"
    >
      {{ $t('CampaignForm_Locations_AddLocations_AddIBeacon') }}
    </el-button>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import AddLocationDialog from '@/modules/campaign-manage/components/locations/AddLocationDialog'
import { EventBus } from '@/core/EventBus'
import {
  locationTypes,
  locationLabels
} from '@/modules/campaign-manage/components/locations/locationsEnum'

export default {
  name: 'AddLocations',
  components: { AddLocationDialog, FormSection },
  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      showDialog: false,
      locationLabels,
      locationType: null
    }
  },

  mounted() {
    EventBus.$on('addLocationDialog', callback => {
      this.showDialog = false
    })

    EventBus.$on('applyLocation', callback => {
      this.showDialog = false
      const data = this.model.locations.filter(element => {
        return element.type !== callback.type
      })

      this.model.locations = data.concat(callback.selection)
    })
  },

  methods: {
    addIBeacon() {
      this.locationType = locationTypes.iBeacon
      this.showDialog = true
    },

    addGeoFence() {
      this.locationType = locationTypes.geo
      this.showDialog = true
    },

    removeLocation(index) {
      this.model.locations.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.locations-table {
  width: 600px;
  margin-bottom: 24px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

>>> .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f8fafc;
}

>>> .el-button {
  width: 165px;
}

.iconCt {
  display: flex;
  justify-content: center;
}

.icon {
  display: flex;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #a7acba;
}

.icon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/locations/AddLocations.vue